import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Alert,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useApi } from "../../utils/api";
import { useUserInfo } from "../../utils/user";

export default function InstagramCallback() {
  const { connectInstagram, getCoachProfileMe, saveCoachProfile } = useApi();
  const { id: userId } = useUserInfo();
  const navigate = useNavigate();
  const [status, setStatus] = useState({ loading: true, error: "", ok: false });

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const error = params.get("error");
      const errorDesc = params.get("error_description");

      if (error) {
        setStatus({
          loading: false,
          ok: false,
          error: `${error}${errorDesc ? `: ${errorDesc}` : ""}`,
        });
        return;
      }
      if (!code) {
        setStatus({
          loading: false,
          ok: false,
          error: "Missing code in callback URL",
        });
        return;
      }
      if (!userId) {
        setStatus({
          loading: false,
          ok: false,
          error: "Missing userId (user not logged in?)",
        });
        return;
      }

      const state = localStorage.getItem("ig_oauth_state") || "";

      try {
        const j = await connectInstagram(code, userId, state);
        if (j.error) throw new Error(j.error || "Failed to connect Instagram");

        // Update coach profile with Instagram username if available
        if (j.igUser?.username) {
          try {
            const currentProfile = (await getCoachProfileMe()) || {};
            await saveCoachProfile({
              ...currentProfile,
              instagramUsername: j.igUser.username,
            });
          } catch (profileErr) {
            console.error("Failed to update coach profile:", profileErr);
            // Don't fail the whole flow if profile update fails
          }
        }

        setStatus({ loading: false, ok: true, error: "" });

        // clear saved state
        localStorage.removeItem("ig_oauth_state");

        // send user somewhere useful
        setTimeout(() => navigate("/coach-profile"), 600);
      } catch (e) {
        setStatus({ loading: false, ok: false, error: e.message });
      }
    };

    run();
  }, [userId, navigate, connectInstagram, getCoachProfileMe, saveCoachProfile]);

  return (
    <Box sx={{ maxWidth: 520, mx: "auto", mt: 6 }}>
      <Stack spacing={2}>
        <Typography variant="h5">Instagram Connection</Typography>

        {status.loading && (
          <Stack direction="row" spacing={2} alignItems="center">
            <CircularProgress />
            <Typography>Connecting…</Typography>
          </Stack>
        )}

        {status.error && <Alert severity="error">{status.error}</Alert>}
        {status.ok && <Alert severity="success">Instagram connected!</Alert>}

        <Button variant="outlined" onClick={() => navigate("/coach-profile")}>
          Back to Profile
        </Button>
      </Stack>
    </Box>
  );
}
